module.exports = __webpack_public_path__ + "img/facebook-square-brands.2200d0d4.svg";